/* eslint-disable */
import { trackResourceEvent } from '../omega';
import { utils } from '../utils';
export const autoTrackMixins = {
    methods: {
        getEffectiveEvent(eventList, { includeList = [], excludeList = [] }) {
            let model = 'normal';
            if (includeList.length > 0 && excludeList.length === 0)
                model = 'include';
            if (includeList.length === 0 && excludeList.length > 0)
                model = 'exclude';
            if (includeList.length > 0 && excludeList.length > 0)
                model = 'both';
            switch (model) {
                case 'normal': // 正常模式
                    return eventList;
                case 'include': // 包含模式
                    return eventList.reduce((list, event) => {
                        if (includeList.includes(event))
                            list.push(event);
                        return list;
                    }, []);
                case 'exclude': // 排除模式
                    return eventList.reduce((list, event) => {
                        if (!excludeList.includes(event))
                            list.push(event);
                        return list;
                    }, []);
                case 'both':
                    return eventList.reduce((list, event) => {
                        if (includeList.includes(event) && !excludeList.includes(event))
                            list.push(event);
                        return list;
                    }, []);
            }
        },
        hack(currentVNode) {
            const xposAttrs = ['resname', 'spm', 'name'];
            const hackList = ['_c', '$createElement'];
            hackList.forEach((api) => {
                const originApi = currentVNode[api];
                currentVNode[api] = (...args) => {
                    const [ele, config] = args;
                    const enhance = (ele, config) => {
                        if (xposAttrs.some((attr) => config.attrs[`data-x-${attr}`]) ||
                            config.attrs['data-x-index']) {
                            ;
                            ['nativeOn', 'on'].forEach((eventSet) => {
                                if (utils.isObj(config[eventSet])) {
                                    const eventList = config[eventSet];
                                    let effectiveEventList = Object.keys(config[eventSet]);
                                    if (['include', 'exclude'].some((attr) => config.attrs[`data-x-${attr}`])) {
                                        const includeList = config.attrs[`data-x-include`]
                                            ? config.attrs[`data-x-include`].split(',')
                                            : [];
                                        const excludeList = config.attrs[`data-x-exclude`]
                                            ? config.attrs[`data-x-exclude`].split(',')
                                            : [];
                                        effectiveEventList = this.getEffectiveEvent(effectiveEventList, {
                                            includeList,
                                            excludeList
                                        });
                                    }
                                    /* 遍历当前组件/元素上挂载的所有事件 */
                                    Object.keys(eventList).forEach((fn) => {
                                        /* 满足自动触发条件的事件 进行代理 */
                                        if (effectiveEventList.includes(fn)) {
                                            const originFn = config[eventSet][fn];
                                            config[eventSet][fn] = (...eventArgs) => {
                                                console.log('=== 自动埋点 捕获组件/元素事件 ===', ele, config);
                                                /* 整理xpos信息 */
                                                let resource = config.attrs;
                                                let info = {};
                                                /* 是否存在上下文 */
                                                const contextAttrsExist = utils.isObj(this.$attrs);
                                                if (contextAttrsExist) {
                                                    /* 存在index 但是元素本身没有声明xpos相关属性 则判断是否为组件场景 并检查组件实例上属性 */
                                                    if (config.attrs['data-x-index'] &&
                                                        !xposAttrs.some((attr) => config.attrs[`data-x-${attr}`])) {
                                                        if (this.$attrs &&
                                                            xposAttrs.some((attr) => this.$attrs[`data-x-${attr}`])) {
                                                            /* 存在实例上的xpos 则以实例上的xpos作为兜底上报 */
                                                            resource = this.$attrs;
                                                        }
                                                        else {
                                                            /* 实例上也不存在xpos 则以unknown-position-name的错误标识上报 只为记录 */
                                                            resource = this.$attrs;
                                                            resource = {
                                                                'data-x-name': 'unknown-position-name'
                                                            };
                                                        }
                                                    }
                                                    /* 组件场景下 如果组件上存在xpos信息 作为cid上报 */
                                                    const attr = xposAttrs.find((attr) => this.$attrs[`data-x-${attr}`]);
                                                    if (attr) {
                                                        info['component_id'] = this.$attrs[`data-x-${attr}`];
                                                    }
                                                    /* 列表场景下 需要将组件实例上的index 与 当前元素的index 进行拼接 */
                                                    if (config.attrs['data-x-index'] &&
                                                        this.$attrs['data-x-index']) {
                                                        info['index'] =
                                                            this.$attrs['data-x-index'] +
                                                                '+' +
                                                                config.attrs['data-x-index'];
                                                    }
                                                    else {
                                                        info['index'] = config.attrs['data-x-index'];
                                                    }
                                                }
                                                info = {
                                                    ...info,
                                                    element_name: resource['data-x-name'],
                                                    resname: resource['data-x-resname'],
                                                    spm: resource['data-x-spm'],
                                                    // @ts-ignore
                                                    component_id: info.component_id || '' // 数据侧要求cid保留key值
                                                };
                                                /* End 整理xpos信息 */
                                                /* 整理业务数据 */
                                                const _data = config.attrs['data-x-state'];
                                                /* End 整理业务数据 */
                                                /* 自动埋点上报 */
                                                console.log('=== 自动埋点 hacked ===', info, _data);
                                                trackResourceEvent(info, _data, {});
                                                /* End 自动埋点上报 */
                                                /* 继续执行原方法 */
                                                originFn(...eventArgs);
                                                /* End 继续执行原方法 */
                                            };
                                        }
                                    });
                                }
                            });
                        }
                    };
                    if (config && config.attrs)
                        enhance(ele, config);
                    return originApi(...args);
                };
            });
        }
    },
    /* for vue */
    created() {
        this.hack(this);
    },
    data() {
        return {};
    },
    computed: {},
};
